export const acessibilidadeEn = {
  kanban: {
    papel: 'draggable card',
    instrucoes: 'Enter opens the card. Space picks up the card; the left and right arrows choose the column; Space drops it and Esc cancels.',
    inicio: 'Picked up card {{titulo}}. Use the arrow keys to choose the column.',
    sobre: 'Card {{titulo}} is over column {{coluna}}.',
    solto: 'Card {{titulo}} dropped in column {{coluna}}.',
    soltoFora: 'Card {{titulo}} dropped outside a column and returned to its place.',
    cancelado: 'Move cancelled. Card {{titulo}} went back to its place.',
    cartao: 'card',
    colunas: 'Board columns',
    colunaPapel: 'draggable column',
    moverColuna: 'Move column {{coluna}}',
    instrucoesColuna: 'Space picks up the column; the left and right arrows choose the position; Space drops it and Esc cancels. Alt with the left or right arrow moves the column straight away.',
    colunaInicio: 'Picked up column {{coluna}}. Use the arrow keys to choose the position.',
    colunaSobre: 'Column {{coluna}} in place of column {{destino}}.',
    colunaSolta: 'Column {{coluna}} moved to the place of column {{destino}}.',
    colunaCancelada: 'Move cancelled. Column {{coluna}} went back to its place.',
  },
  pular: { conteudo: 'Skip to content' },
  tema: { escuro: 'Dark theme', atual: 'Current theme: {{tema}}. Click to switch.' },
  avisos: { regiao: 'Notifications (F8 goes to the latest one)', fechar: 'Close notification' },
  calendario: { diaInteiro: 'All day', eventos_one: '{{count}} event', eventos_other: '{{count}} events', eventosDoDia: 'Events on {{data}}', eventosDoHorario: 'Events on {{data}}, {{hora}}', criarEm: 'Create on {{quando}}', mostrarMais: 'Show {{n}} more ({{total}} left)' },
  busca: {
    resultados_one: '{{count}} result',
    resultados_other: '{{count}} results',
  },
};
